
import { defuFn } from '/home/gitlab-runner/builds/52ykkrvhr/0/nationalhorseman/nationalhorseman-laravel-8/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
